import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function FinalCTA() {
  const trustItems = ['Diagnostic inspection applied toward repair', '2-year / 24,000-mile warranty', '4.9 stars · 595+ reviews', 'Serving St. Paul since 1977'];
  return <section id="book" className="py-24 px-4 bg-[#C8B4A4] text-brand-dark relative overflow-hidden" data-id="element-52">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-[0.07]" style={{
      backgroundImage: 'radial-gradient(#3b2314 1.5px, transparent 1.5px)',
      backgroundSize: '28px 28px'
    }} data-id="element-53"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-55">
          <span className="uppercase tracking-widest text-sm font-extrabold text-brand-dark/80 mb-4 block" data-id="element-56">
            Stop guessing.
          </span>
          <h2 className="font-heading uppercase tracking-wide text-4xl md:text-5xl lg:text-6xl font-extrabold mb-8 pl-[0px] pr-[0px]" data-id="element-57">
            Modern diagnostics for Modern cars
          </h2>
          <p className="text-xl md:text-2xl font-medium text-brand-dark/90 mb-6 max-w-3xl mx-auto leading-relaxed" data-id="element-58">
            If you’re still dealing with a warning light or a problem that
            hasn’t been solved, a proper diagnostic inspection can provide clear
            answers.
          </p>
          <p className="text-lg md:text-xl font-medium text-brand-dark/80 mb-12 max-w-3xl mx-auto" data-id="element-59">
            You'll receive photos, video, and a clear explanation of what we
            find so you can make an informed decision before any work begins.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-6 mb-12" data-id="element-60">
            <a href="tel:6512240267" className="w-full sm:w-auto px-10 py-5 bg-brand-dark hover:bg-gray-800 text-white text-lg font-bold rounded-md transition-colors shadow-2xl inline-flex justify-center items-center" data-id="element-61">
              Book Diagnostic Inspection
            </a>
            <a href="tel:6512240267" className="w-full sm:w-auto px-10 py-5 bg-transparent border-2 border-brand-dark hover:bg-brand-dark/10 text-brand-dark text-lg font-bold rounded-md transition-colors flex items-center justify-center gap-2" data-id="element-62">
              Call (651) 224-0267
            </a>
          </div>

          <div className="bg-brand-dark/10 border border-brand-dark/20 rounded-xl px-6 py-5 inline-block mt-[10px] mb-[10px]" data-id="element-63">
            <p className="text-lg font-bold text-brand-dark" data-id="element-64">
              You can also book your appointment online at{' '}
              <a href="https://lancerservice.com" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-brand-dark/80 transition-colors" data-id="element-65">
                lancerservice.com
              </a>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}